import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { UserLoginService } from 'src/app/login/userlogin.service';
import { SchoolImgMasterService } from 'src/app/School/BackOffice/school-img/school-img-master.service';
import { UserAffiliationMappingReadByUserIdRequestDTO } from 'src/app/School/SchoolUserMapping/user-affiliation-mapping.interface';
import { UserAffiliationMappingService } from 'src/app/School/SchoolUserMapping/user-affiliation-mapping.service';
import { UserSharedService } from 'src/app/Shared Utilities/user-shared.service';

@Component({
  selector: 'app-welcome-page',
  templateUrl: './welcome-page.component.html',
  styleUrls: ['./welcome-page.component.css']
})
export class WelcomePageComponent implements OnInit, OnDestroy {
  private userShared = inject(UserSharedService);
  private userLoginService = inject(UserLoginService);
  private schoolUserMappingService = inject(UserAffiliationMappingService);

  private schoolImgService = inject(SchoolImgMasterService);
  User = this.userLoginService.User();

  firstName = '';
  selectedSchoolId = 0;

  defaultWelcomeImage = 'assets/images/welcome/school.png';
  schoolBackgroundImage = this.defaultWelcomeImage;

  private subscription!: Subscription;

  private bannerUpdateHandler = (event: Event) => {
    const customEvent = event as CustomEvent;
    const detail = customEvent.detail || {};

    const eventSchoolId = Number(detail.schoolId || 0);

    if (eventSchoolId && eventSchoolId === Number(this.selectedSchoolId)) {
      this.schoolBackgroundImage = detail.imgPath || this.defaultWelcomeImage;
    }
  };

  ngOnInit(): void {
    this.subscription = this.userShared.firstName$.subscribe(name => {
      this.firstName = name || '';
    });

    window.addEventListener('schoolWelcomeBannerUpdated', this.bannerUpdateHandler);

    // this.selectedSchoolId = Number(
    //   (this.User as any)?.schoolId ||
    //   (this.User as any)?.selectedSchoolId ||
    //   localStorage.getItem('selectedSchoolId') ||
    //   0
    // );

    // if (this.selectedSchoolId > 0) {
    //   this.loadSchoolWelcomeBanner();
    //   return;
    // }

    if (this.User?.userId) {
      this.getUserMapping(Number(this.User.userId));
    }
  }

  getUserMapping(userId: number): void {
    const data: UserAffiliationMappingReadByUserIdRequestDTO = { userId };

    this.schoolUserMappingService.UserAffiliationMapping_ReadByUserId(data).subscribe({
      next: (res) => {
        const userData = res.items || [];

        if (!userData.length) {
          this.schoolBackgroundImage = this.defaultWelcomeImage;
          return;
        }

        this.selectedSchoolId = Number(userData[0].schoolId || 0);

        if (this.selectedSchoolId > 0) {
          localStorage.setItem('selectedSchoolId', this.selectedSchoolId.toString());
          this.loadSchoolWelcomeBanner();
        }
      },
      error: () => {
        this.schoolBackgroundImage = this.defaultWelcomeImage;
      }
    });
  }

  loadSchoolWelcomeBanner(): void {
  if (!this.selectedSchoolId) {
    this.schoolBackgroundImage = this.defaultWelcomeImage;
    return;
  }

  const savedBanner = localStorage.getItem(
    `school_welcome_banner_${this.selectedSchoolId}`
  );

  if (savedBanner) {
    this.schoolBackgroundImage = savedBanner;
  }

  const payload = {
    masterId: this.selectedSchoolId,
    masterType: 'School'
  };

  this.schoolImgService.SchoolImgMaster_ReadByMasterId(payload).subscribe({
    next: (res: any) => {
      const images = res?.items || [];

      const defaultImage =
        images.find((x: any) => Number(x.isDefault) === 1) ||
        images[0];

      if (defaultImage?.imgPath) {
        this.schoolBackgroundImage = defaultImage.imgPath;

        localStorage.setItem(
          `school_welcome_banner_${this.selectedSchoolId}`,
          defaultImage.imgPath
        );
      } else {
        this.schoolBackgroundImage = this.defaultWelcomeImage;
      }
    },
    error: () => {
      this.schoolBackgroundImage = savedBanner || this.defaultWelcomeImage;
    }
  });
}

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    window.removeEventListener('schoolWelcomeBannerUpdated', this.bannerUpdateHandler);
  }
}